import { commons } from "@/services/requests";
import { useQuery } from "react-query";

export default function useBreadCrumbs(id: number | string) {
  const { data: breadCrumbs, isLoading: isLoadingBreadCrumbs } = useQuery(
    ["BREADCRUMBS", id],
    commons.getBreadCrumbs
  );

  return {
    breadCrumbs,
    isLoadingBreadCrumbs,
  };
}
